export default __webpack_public_path__ + "static/Chateau-Montelena-ffb8fbe841a261dcee6e7841f3d35f2f.jpg";